<template>
  <div class="car-banner" :class="{'car-banner_mobile': mobile, 'rtl': locale === 'ar'}" v-if="show">
    <div class="car-banner__wrapper">
      <div class="car-banner__start">
        <a :href="`https://www.qic.car${localeAr}`" target="_blank">
          <img src="../../assets/images/banner-logo.svg" alt="qic car">
        </a>
        <a :href="`https://www.qic.car${localeAr}`" target="_blank" class="car-banner__link">
          <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4705 11.8292C11.4705 11.2079 11.9742 10.7042 12.5955 10.7042L22.1414 10.7042C22.7628 10.7042 23.2664 11.2079 23.2664 11.8292V21.3752C23.2664 21.9965 22.7628 22.5002 22.1414 22.5002C21.5201 22.5002 21.0164 21.9965 21.0164 21.3752V14.5452L12.5955 22.9662C12.1562 23.4055 11.4438 23.4055 11.0045 22.9662C10.5652 22.5268 10.5652 21.8145 11.0045 21.3752L19.4254 12.9542L12.5955 12.9542C11.9742 12.9542 11.4705 12.4506 11.4705 11.8292Z" fill="#5927FF"/>
          </svg>
        </a>
        <a :href="`https://www.qic.car${localeAr}`" target="_blank" class="car-banner__offer">
          {{ $t('car_banner.offer.item_1') }}
          <span class="car-banner__underline">{{ $t('car_banner.offer.item_2') }}</span>
          {{ $t('car_banner.offer.item_3') }}
          <span class="car-banner__offer-inner">{{ $t('car_banner.offer.item_4') }}</span>
        </a>
      </div>
      <div class="car-banner__end">
        <a :href="`https://www.qic.car${localeAr}`" target="_blank" class="car-banner__link">
          <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.01943 8.16367C8.01943 7.74945 8.35522 7.41367 8.76943 7.41367L15.1334 7.41367C15.5476 7.41367 15.8834 7.74945 15.8834 8.16367V14.5276C15.8834 14.9418 15.5476 15.2776 15.1334 15.2776C14.7192 15.2776 14.3834 14.9418 14.3834 14.5276L14.3834 9.97433L8.76943 15.5883C8.47654 15.8812 8.00166 15.8812 7.70877 15.5883C7.41588 15.2954 7.41588 14.8205 7.70877 14.5276L13.3227 8.91367L8.76943 8.91367C8.35522 8.91367 8.01943 8.57788 8.01943 8.16367Z" fill="#5927FF"/>
          </svg>
          {{ $t('car_banner.link') }}
        </a>
        <div class="car-banner__close" @click="close">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5.61084L5 15.6108M5 5.61084L15 15.6108" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarBanner',
  props: {
    mobile: { type: Boolean, default: false }
  },
  data () {
    return {
      show: true
    }
  },
  computed: {
    locale () {
      return this.$i18n.locale
    },
    localeAr () {
      return this.locale === 'ar' ? '/ar' : ''
    }
  },
  methods: {
    close () {
      this.show = false
      localStorage.setItem('car_banner', 1)
    }
  },
  mounted () {
    const param = 'nobar'
    const redUrl = this.$route.query?.welcome
    if (redUrl?.includes(param)) {
      localStorage.setItem('car_banner', 1)
    }
    this.show = !redUrl?.includes(param) && !localStorage.getItem('car_banner')
  }
}
</script>

<style lang="scss" scoped>
.car-banner {
  background: #5927FF;
  mix-blend-mode: normal;
  border-radius: 0px 0px 15px 15px;
  padding: 13px 30px;
  @media(max-width: 1199px) {
    padding: 12px 24px;
  }
  @media(max-width: 767px) {
    display: none;
  }
  &_mobile {
    display: none;
    @media(max-width: 767px) {
      display: block;
      position: relative;
      margin: 24px 16px 16px;
      border-radius: 15px;
      padding: 16px 40px 16px 16px;
    }
  }
  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__start {
    display: flex;
    align-items: center;
    img {
      margin-inline-end: 16px;
      @media(max-width: 767px) {
        display: none;
      }
    }
    .car-banner__link {
      display: none;
      @media(max-width: 767px) {
        display: flex;
      }
    }
  }

  &__offer {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    &-inner {
      font-weight: 500;
      color: rgba(255, 255, 255, 0.7);
      @media(max-width: 1199px) {
        display: block;
      }
    }
    @media(max-width: 1199px) {
      font-size: 14px;
      line-height: 19px;
      &-inner {
        font-size: 12px;
        line-height: 16px;
        margin-top: 2px;
      }
    }
  }

  &__underline {
    position: relative;
    color: #82FF5A;
    &::after {
      position: absolute;
      content: "";
      bottom: -4px;
      inset-inline-start: 0;
      width: 100%;
      height: 5px;
      background: url(../../assets/images/car-banner-underline.svg) no-repeat center/cover;
    }
  }

  &__end {
    display: flex;
    align-items: center;
  }

  &__link {
    display: grid;
    grid-template-columns: 16px auto;
    gap: 8px;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.1px;
    color: #0D0C22;
    background: #FFFFFF;
    border: 1px solid #F1F4F6;
    border-radius: 12px;
    padding: 10px 16px;
    flex-shrink: 0;
    transition: opacity .2s ease;
    margin-inline-end: 8px;
    &:hover {
      @media(min-width: 1024px) {
        opacity: .8;
      }
    }
    @media(max-width: 767px) {
      display: none;
      width: 48px;
      height: 48px;
      border-radius: 100px;
      padding: 0;
      margin-inline-end: 16px;
    }
  }

  &__close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
    @media(max-width: 767px) {
      position: absolute;
      top: 8px;
      inset-inline-end: 8px;
    }
  }
  &.rtl {
    direction: rtl;
    @media(max-width: 767px) {
      padding: 16px 16px 16px 40px;
    }
    .car-banner {
      &__link svg {
        transform: scale(-1, 1);
      }
      &__end {
        .car-banner__link svg {
          position: relative;
          top: -3px;
        }
      }
    }

  }
}
</style>
